import React, { useEffect, useState } from "react";
import VisitSummaryAccordion from "components/visitSummaryAccordion/VisitSummaryAccordion";
import VisitSummaryHeader from "components/visitSummaryAccordion/VisitSummaryHeader";
import VisitDetailsForBHSummary from "./VisitDetailsForBHSummary";
import DOMPurify from "dompurify";
import Images from "assets/images";
import { ContentText, MedicalHistory } from "pages/home/myVisits/MiscComponents";
import BHLegalAgreementContent from "../phaseTwoSections/BHLegalAgreementContent";
import moment from "moment";

function BehaviorHealthVisitSummary({ readOnly, data }) {
  const [terms, setTerms] = useState([]);

  useEffect(() => {
    setTerms(data?.code_of_conduct);
  }, [data]);

  const accordionData = [
    {
        header: (props) => (
            <VisitSummaryHeader {...props} title={"Visit Details"} />
        ),
        content: <VisitDetailsForBHSummary readOnly={readOnly} data={data} />,
    },
    {
        header: (props) => (
            <VisitSummaryHeader {...props} title={"Symptoms"} />
        ),
        content: <div className="flex flex-col p-4 mb-4 space-y-4 rounded-md bg-backgroundWhite">{data?.behavior_health_symptoms?.length > 0 && (
            <ContentText
                comma={false}
                child={data.behavior_health_symptoms}
            />
        )}</div>,
    },
    {
        header: (props) => (
            <VisitSummaryHeader {...props} title={"Medical History"} />
        ),
        content: <div className="-mx-4"><MedicalHistory data={data} /></div>,
    },
    {
      header: (props) => (
        <VisitSummaryHeader {...props} title="SkyMD's Code Of Conduct" />
      ),
      content: (
        <div>
          {terms?.map((term, index) => {
            return (
              <div className="py-10" key={index}>
                <div className="flex">
                  <img
                    className="w-8 h-8 mt-2"
                    src={Images.checkedOrange}
                    alt="checked"
                  />
                  <p
                    className="pl-5 text-2xl leading-8 font-light pt-1"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(term),
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ),
    },
    {
      header: (props) => (
        <VisitSummaryHeader {...props} title="Terms & Conditions" />
      ),
      content: (
        <div className="font-medium text-xl">
          <BHLegalAgreementContent />
          <div className="pt-5 flex items-center">
            <img
              className="w-6 h-6"
              src={
                Images.checkedOrange
              }
              alt="checked"
            />
            <p className="pl-2 text-xl leading-8 font-bold pt-1">I have read and agree to the terms of the agreement</p>
          </div>
          <div className="pt-5 flex items-center">
            <img
              className="w-6 h-6"
              src={
                Images.checkedOrange
              }
              alt="checked"
            />
            <p className="pl-2 text-xl leading-8 font-bold pt-1">I have read and agree to the Cancellation and No Show Policy</p>
          </div>
          <div className="py-6">
            <p className="text-xl leading-8 font-bold">Name: <span className="font-bold">{data?.accepted_legal_step_by}</span></p>
            <p className="text-xl leading-8 font-bold">Time Stamp: <span className="font-bold">{moment(data?.accepted_legal_step_at).format("MMM DD, YYYY hh:mm A")}</span></p>
          </div>
        </div>
      ),
    },
  ];
  return (
    <div className="bg-alternativeWhite">
      <div className="wrapper px-12">
        {readOnly ? null : (
          <h2 className="uppercase font-black text-xl pt-8">
            Here is your Visit Summary
          </h2>
        )}
        <VisitSummaryAccordion accordionData={accordionData} />
      </div>
    </div>
  );
}

export default BehaviorHealthVisitSummary;